import { styled as styledHexa } from '@bees-web/hexa-styling'

/**
 * Stable page shell for CLS during client hydration.
 * Reserves viewport height and anchors the last top-level block (footer)
 * to the bottom while header/content blocks are still mounting.
 */
const viewportMinHeight = {
  minHeight: '100vh',
  '@supports (height: 100dvh)': {
    minHeight: '100dvh',
  },
}

export const PageContainer = styledHexa('div', {
  display: 'flex',
  flexDirection: 'column',
  ...viewportMinHeight,
})

export const PageBody = styledHexa('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: '1 0 auto',
  ...viewportMinHeight,
  '& > *:last-child': {
    marginTop: 'auto',
  },
})
